<template>
  <div class="headline">
    <!-- <div class="headline__sign">
      <div class="headline__sign--vertical" />
      <div class="headline__sign--horizontal" />
    </div> -->
    <img src="/assets/images/pages/rodo/rodo-headline.png" >
    <div class="headline__number"><b>{{ number }}</b></div>
    <span v-html="value" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    number: {
      type: [ String, Number ],
      required: false,
      default: '1',
    },
  },
}
</script>

<style lang="scss" scoped>
.headline {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  &__number {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background-color: #009CE9;
    color: #fff;
    font-size: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 15px 0 8px;
    flex: 0 0 auto;
  }

  span {
    text-transform: uppercase;
    color: #1F72B2;
    font-size: 25px;
    font-weight: lighter;
  }

  b {
    margin-top: 3px;
  }

  img {
    width: 16px;
    flex: 0 0 auto;
  }

  &__sign {
    position: relative;
    width: 12px;

    &--vertical {
      background-image: linear-gradient(to right, #1F72B2 40%, rgba(255, 255, 255, 0) 20%);
      background-position: top;
      background-size: 6px 2px;
      background-repeat: repeat-x;
      width: 11px;
      height: 2px;
      position: absolute;
      top: 19px;
      left: 2px;
    }

    &--horizontal {
      background-image: linear-gradient(to bottom, #1F72B2 40%, rgba(255, 255, 255, 0) 20%);
      background-position: right;
      background-size: 2px 5px;
      background-repeat: repeat-y;
      width: 2px;
      height: 44px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/Headline.vue